import { ASC } from '../../../shared';
import { IOrderBy } from './ListView.interfaces';
import { Sortable } from './ListView.types';

export const GRADE: Sortable = 'GRADE';
export const YEAR: Sortable = 'YEAR';
export const BLOCK: Sortable = 'BLOCK';
export const TYPE: Sortable = 'TYPE';
export const CC: Sortable = 'CC';
export const QUESTION_ID: Sortable = 'QUESTION_ID';
export const DIFFICULTY: Sortable = 'DIFFICULTY';

export const SORT_BY_GRADE = 'grade';
export const SORT_BY_YEAR = 'year';
export const SORT_BY_BLOCK = 'block';
export const SORT_BY_TYPE = 'itemType';
export const SORT_BY_CC = 'contentCategories';
export const SORT_BY_DIFFICULTY = 'difficulty';

export const INITIAL_SORT: IOrderBy = {
  selected: BLOCK,
  orderBy: ASC
};

export const REGEX_ID_START = /[A-Za-z]/;
export const REGEX_ID_END = /[A-Za-z]\d/;